import type { Media, VideoContentObject } from 'models';
import { Button, Card, Col, FileCheckLineIcon, Row, VideoLineIcon } from 'ui';
import { useUpdateStatus } from '../../../../queries';
import { VideoUploadForm } from '../../../components';
import { Processing } from './processing';

type P = {
  fullData?: Media;
  trailerData?: Media;
  videoContentObject: VideoContentObject;
};

const UploadVideoCard = ({ fullData, trailerData, videoContentObject }: P) => {
  const { isPending: isLoading, mutate: updateVideoStatus } = useUpdateStatus();

  return (
    <Card title={<Card.Title icon={<VideoLineIcon />}>Video files</Card.Title>}>
      <Row gutter={[0, 'ms']}>
        {trailerData?.alts?.stream?.status === 'processing' || fullData?.alts?.stream?.status === 'processing' ? (
          <Col span={24}>
            <Processing />
          </Col>
        ) : null}

        <Col span={24}>
          <Row>
            <Col span={24}>
              <VideoUploadForm fullData={fullData} trailerData={trailerData} video={videoContentObject.video} />
            </Col>
            {/* TODO: resolve real rule and type safety on rendering components that needs fullData and trailerData */}
            {fullData?.alts?.stream?.status === 'active' && trailerData?.alts?.stream?.status === 'active' ? (
              <Col span={24}>
                <Button
                  block
                  icon={<FileCheckLineIcon />}
                  loading={isLoading}
                  onClick={() => {
                    updateVideoStatus({ id: videoContentObject.video.id, video: { status: 'published' } });
                  }}
                  size="large"
                  type="secondary"
                >
                  Publish
                </Button>
              </Col>
            ) : null}
          </Row>
        </Col>
      </Row>
    </Card>
  );
};

export default UploadVideoCard;
